import { call, put, takeEvery } from "redux-saga/effects";
import { gradeActions } from "./gradingModelSlice";
import {
  getGradeInfo,
  getById,
  updateById,
  create as createGrade,
  deleteById as deleteGrade,
} from "./gradingModelBaseApi";
import { toastAction } from "../toast/toast";

export function* onChangeGrade(payload) {
  try {
    const { data } = yield call(getGradeInfo, payload);
    yield put(gradeActions.setGrade(data || {}));
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

export function* onChangeCurrentGrade({ payload }) {
  try {
    const { data } = yield call(getById, payload);
    yield put(gradeActions.setCurrentGrade(data || {}));
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message));
  }
}

export function* onSaveCurrentGrade({ payload }) {
  let { grade, navigate } = payload;
  try {
    const { data, message } = yield call(updateById, grade);
    yield put(gradeActions.setCurrentGrade(data || {}));
    yield put(toastAction.onSuccToast(`Grading Model Update Success`));
    try {
      navigate("/grading-model", { replace: true });
    } catch (e) {}
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

export function* onCreateGrade({ payload }) {
  let { grade, navigate } = payload;
  try {
    const { data, message } = yield call(createGrade, grade);
    yield put(toastAction.onSuccToast(`Grading Model Create Success`));
    try {
      navigate("/grading-model", { replace: true });
    } catch (e) {}
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

export function* onDeleteGrade({ payload }) {
  try {
    yield put(gradeActions.deleteGrade(payload));

    const { data, message } = yield call(deleteGrade, payload);
    yield put(toastAction.onSuccToast(`Grading Model Delete Success`));
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

export function* onUpdateStatusById({ payload }) {
  try {
    const { data, message } = yield call(updateStatusById, payload);
    yield put(gradeActions.setCurrentGrade(data || {}));
    yield put(toastAction.onSuccToast(message));
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

function* gradeWatcherSaga() {
  yield takeEvery(gradeActions.loadGrade.type, onChangeGrade);
  yield takeEvery(gradeActions.loadCurrentGrade.type, onChangeCurrentGrade);
  yield takeEvery(gradeActions.saveCurrentGrade.type, onSaveCurrentGrade);
  yield takeEvery(gradeActions.createGrade.type, onCreateGrade);
  yield takeEvery(gradeActions.removeGrade.type, onDeleteGrade);
  yield takeEvery(gradeActions.updateStatus.type, onUpdateStatusById);
}

export default gradeWatcherSaga;
